import React from "react";
import { Typography, TypographyProps } from "@mui/material";

interface AIDisclaimerProps {
  variant?: TypographyProps["variant"];
  sx?: TypographyProps["sx"];
}

export const AIDisclaimer: React.FC<AIDisclaimerProps> = ({
  variant = "caption",
  sx = {},
}) => {
  return (
    <Typography
      variant={variant}
      color="text.secondary"
      sx={{
        display: "block",
        textAlign: "center",
        fontSize: "0.75rem",
        ...sx,
      }}
    >
      Stratify can make mistakes. Review important information.
    </Typography>
  );
};